// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__H_1IU","wrapper":"styles_wrapper__s5ynb","item":"styles_item__gOW0F","wrp":"styles_wrp__w_jHi","circle":"styles_circle__JBTdv"};